import { sendAxiosRequest } from '../../utils/sendRequest';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IOrderViewCollectionResponse from '../../../models/responces/IOrderViewCollectionResponse';
import ICollectionParams from '../../../models/params/ICollectionParams';

export interface IApiOrderViewCollectionParams {
  collectionParams: ICollectionParams;
}
const apiOrderViewCollection = (params: IApiOrderViewCollectionParams) =>
  sendAxiosRequest({
    method: 'get',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'order',
      action: 'view-collection',
      collectionParams: params.collectionParams
    }),
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IOrderViewCollectionResponse>;
export default apiOrderViewCollection;
